import { render, staticRenderFns } from "./TMResultsDataTable.vue?vue&type=template&id=4620d616&scoped=true"
import script from "./TMResultsDataTable.vue?vue&type=script&lang=js"
export * from "./TMResultsDataTable.vue?vue&type=script&lang=js"
import style0 from "./TMResultsDataTable.vue?vue&type=style&index=0&id=4620d616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620d616",
  null
  
)

export default component.exports